// extracted by mini-css-extract-plugin
export default {"wrap":"UI-z","fullWidth":"VI-z","hideOnDesktop":"WI-z","content":"XI-z","hasOpenedNav":"YI-z","crumbsList":"ZI-z","dropdownsWrap":"_I-z"};